import React from 'react'

import { routes } from 'constants/routes'
import { LinkButton } from 'components/Button'

import { Banner } from './WorkspaceSettingsSubscribePanel.styles'

interface WorkspaceSettingsSubscribePanelProps {
  workspaceId: string
}

export const WorkspaceSettingsSubscribePanel: React.FC<WorkspaceSettingsSubscribePanelProps> = ({
  workspaceId,
}) => (
  <Banner
    title="Enjoying Sketch?"
    text={
      <span>
        To keep using this Workspace after the trial ends, set up a
        subscription.
      </span>
    }
    action={
      <LinkButton
        to={routes.WORKSPACE_SUBSCRIBE.create({
          workspaceId,
        })}
        variant="primary-untinted"
        small>
        Subscribe to Sketch
      </LinkButton>
    }
  />
)
